import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

import { computed, observable, makeObservable, runInAction, action } from "mobx";
var CouponModel = (_class = /*#__PURE__*/function () {
  function CouponModel() {
    _classCallCheck(this, CouponModel);

    _initializerDefineProperty(this, "_couponCode", _descriptor, this);

    _initializerDefineProperty(this, "_isCouponValid", _descriptor2, this);

    _initializerDefineProperty(this, "_couponDiscount", _descriptor3, this);

    _initializerDefineProperty(this, "_appliedCouponCode", _descriptor4, this);

    _initializerDefineProperty(this, "_canRemoveCoupon", _descriptor5, this);

    _initializerDefineProperty(this, "_showCouponCode", _descriptor6, this);

    _initializerDefineProperty(this, "_isCouponLoading", _descriptor7, this);

    makeObservable(this);
  }

  _createClass(CouponModel, [{
    key: "resetModel",
    value: function resetModel() {
      this._couponCode = "";
      this._isCouponValid = true;
      this._couponDiscount = null;
      this._appliedCouponCode = null;
      this._canRemoveCoupon = true;
      this._showCouponCode = true;
      this._isCouponLoading = false;
    }
  }, {
    key: "errors",
    get: function get() {
      return {};
    }
  }, {
    key: "couponCode",
    get: function get() {
      return this._couponCode;
    },
    set: function set(val) {
      var _this = this;

      runInAction(function () {
        _this._couponCode = val;
      });
    }
  }, {
    key: "isCouponValid",
    get: function get() {
      return this._isCouponValid;
    },
    set: function set(val) {
      var _this2 = this;

      runInAction(function () {
        _this2._isCouponValid = val;
      });
    }
  }, {
    key: "couponDiscount",
    get: function get() {
      return this._couponDiscount;
    },
    set: function set(val) {
      var _this3 = this;

      runInAction(function () {
        _this3._couponDiscount = val;
      });
    }
  }, {
    key: "appliedCouponCode",
    get: function get() {
      return this._appliedCouponCode;
    },
    set: function set(val) {
      var _this4 = this;

      runInAction(function () {
        _this4._appliedCouponCode = val;
      });
    }
  }, {
    key: "canRemoveCoupon",
    get: function get() {
      return this._canRemoveCoupon;
    },
    set: function set(val) {
      var _this5 = this;

      runInAction(function () {
        _this5._canRemoveCoupon = val;
      });
    }
  }, {
    key: "showCouponCode",
    get: function get() {
      return this._showCouponCode;
    },
    set: function set(val) {
      var _this6 = this;

      runInAction(function () {
        _this6._showCouponCode = val;
      });
    }
  }, {
    key: "isCouponLoading",
    get: function get() {
      return this._isCouponLoading;
    },
    set: function set(val) {
      var _this7 = this;

      runInAction(function () {
        _this7._isCouponLoading = val;
      });
    }
  }]);

  return CouponModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_couponCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_isCouponValid", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_couponDiscount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_appliedCouponCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_canRemoveCoupon", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_showCouponCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_isCouponLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "couponCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "couponCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCouponValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCouponValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "couponDiscount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "couponDiscount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "appliedCouponCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "appliedCouponCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canRemoveCoupon", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canRemoveCoupon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCouponCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCouponCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCouponLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCouponLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetModel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetModel"), _class.prototype)), _class);
export { CouponModel as default };